import { effect, Injectable, OnDestroy, signal } from "@angular/core";
import { firstValueFrom, Subject } from "rxjs";

@Injectable()
export abstract class BaseResolvableDialogService<TResult, TShowData> implements OnDestroy {
    protected readonly _visible = signal(false);
    protected _dialogSubject: Subject<TResult>;

    readonly visible = this._visible.asReadonly();

    constructor() {
        effect(() => {
            if (!this._visible()) {
                this.resetDialogSubject();
            }
        }, {allowSignalWrites: true});
    }

    ngOnDestroy(): void {
        this.resetDialogSubject();
    }

    public async show(data: TShowData): Promise<TResult> {
        this.resetDialogSubject();
        if (data !== undefined) {
            await this.onShow(data);
        }
        this._visible.set(true);
        this._dialogSubject = new Subject<TResult>();
        return firstValueFrom(this._dialogSubject);
    }

    protected async onShow(data: any): Promise<void> { }

    protected closeWithResult(result: TResult): void {
        this._dialogSubject.next(result);
        this._dialogSubject.complete();
        this._visible.set(false);
    }

    protected resetDialogSubject(): void {
        if (this._dialogSubject && !this._dialogSubject.closed) {
            this._dialogSubject.next(null);
            this._dialogSubject.complete();
        }
    }
}